import productCategoryModule from "./productCategoryModule"
import productCategoryView from "./productCategoryView.html"

productCategoryModule.config(["editionServiceProvider", (editionServiceProvider) =>{
    editionServiceProvider.registerEdition("product-category", productCategoryView, "productCategoryController")
}])